<template>
  <my-modal v-model:visible="visible" hideActions>
    <my-table :data="data" :headers="headers" :query="query" :loading="loading" :editable="false" hide-actions>
      <template v-slot:title>Тэмдэглэл</template>
      <template v-slot:footer>
        <my-button icon="x" @click="visible = false">Хаах</my-button>
      </template>
    </my-table>
  </my-modal>
</template>
<script>
export default {
  props: {
    contractId: { type: Number }
  },
  data () {
    return {
      loading: false,
      data: [[], 0],
      headers: [{
        name: 'isProblem',
        caption: 'Асуудалтай эсэх',
        type: 'Boolean',
        iconTrue: 'exclamation-circle',
        iconFalse: 'check-circle'
      }, {
        name: 'isDrunk',
        caption: 'Уусан эсэх',
        type: 'Boolean'
      }, {
        name: 'note',
        caption: 'Тайлбар'
      }, {
        name: 'createdBy.firstName',
        caption: 'Бүртгэсэн ажилтан'
      }, {
        name: 'createdAt',
        caption: 'Бүртгэсэн огноо',
        type: 'Date'
      }],
      query: { page: 1, limit: 20, sort: [], search: [] }
    }
  },
  computed: {
    visible: {
      get () {
        return !!this.contractId
      },
      set (val) {
        if (!val) {
          this.$emit('update:contractId', null)
        }
      }
    }
  },
  watch: {
    contractId (val) {
      if (val) {
        this.handleRefresh()
      }
    }
  },
  methods: {
    async handleRefresh () {
      try {
        this.loading = true
        this.data = (await this.axios.get(`contracts/customerNoteList/${this.contractId}`, { params: this.query })).data
      } catch (err) {
        this.handleError(err)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
